import { render } from "./authPasswordUpdate.vue?vue&type=template&id=c2beb128&scoped=true"
import script from "./authPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./authPasswordUpdate.vue?vue&type=script&lang=js"

import "./authPasswordUpdate.vue?vue&type=style&index=0&id=c2beb128&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2beb128"]])

export default __exports__